import { Tooltip, Typography, Box, Stack } from '@mui/material'
import { C1Icon } from 'components/core/icons/C1Icon'
import { C1LabeledSwitch } from 'components/core/RHKFormComponents/C1LabeledSwitch'
import { createFormStyles } from 'components/pages/accessrequest/create/form/styles'
import { AccessRequest } from 'components/pages/accessrequest/create/form-v2/RequestAccessFormV2'
import { ZapOff } from 'lucide-react'
import { FC } from 'react'
import { Control, useController } from 'react-hook-form'
import { FormattedMessage } from 'react-intl'

type AccessRequestFormEmergencyFieldProps = {
    control: Control<AccessRequest>
    error?: string
}

export const AccessRequestFormEmergencyField: FC<AccessRequestFormEmergencyFieldProps> = ({
    control,
    error,
}) => {
    const { field: { value: ents } } = useController({
        name: 'ents',
        control,
    })
    // TODO (kans): I think this needs to be fixed in the API to support this
    const disabled = !ents?.length || ents?.length > 1 || !ents[0].emergencyGrantEnabled

    if (disabled) return null

    return <Box>
        <C1LabeledSwitch
            control={control}
            name="emergencyAccess"
            disabled={disabled}
            label={
                <Stack direction="row" alignItems="center" spacing={1}>
                    <Tooltip
                        title={
                            <Box sx={createFormStyles.emergencyAccessToggleTooltip}>
                                <FormattedMessage
                                    id="component_access_request_access_emergency_access_toggle_tooltip"
                                    defaultMessage="Request emergency access if you need to respond to a critical situation."
                                />
                            </Box>
                        }
                        placement="top"
                    >
                        <C1Icon
                            icon={ZapOff}
                            sx={createFormStyles.emergencyAccessIcon}
                            size="sm"
                        />
                    </Tooltip>
                    <Typography variant="h6" component="span">
                        <FormattedMessage
                            id="component_access_request_access_emergency_access_toggle"
                            defaultMessage="Request emergency access"
                        />
                    </Typography>
                </Stack>
            }
            error={!!error}
            helperText={error}
        />
    </Box>
}
